var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8333 11.1333V26.6667C29.8333 27.3739 29.5524 28.0522 29.0523 28.5523C28.5522 29.0524 27.8739 29.3333 27.1667 29.3333H5.83332C5.12608 29.3333 4.4478 29.0524 3.9477 28.5523C3.44761 28.0522 3.16666 27.3739 3.16666 26.6667V11.1333C3.1688 10.6015 3.32991 10.0825 3.62927 9.64297C3.92864 9.20343 4.35259 8.86343 4.84666 8.66667L15.5133 4.4C16.1469 4.14767 16.8531 4.14767 17.4867 4.4L28.1533 8.66667C28.6474 8.86343 29.0713 9.20343 29.3707 9.64297C29.6701 10.0825 29.8312 10.6015 29.8333 11.1333Z",
    stroke: "#6938EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 24H24.5",
    stroke: "#6938EF",
    strokeWidth: 1.55,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 18.6667H24.5",
    stroke: "#6938EF",
    strokeWidth: 1.55,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 13.3333H8.5V29.3333H24.5V13.3333Z",
    stroke: "#6938EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.7398da45ec243ec00d74891f1d298a27.svg";
export { ForwardRef as ReactComponent };